module.exports = "## Avatar\n\nAvatars can be used to represent people or object.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Avatar/README.md
 ** module id = 938
 ** module chunks = 0
 **/